export interface IARTemplateFilterCriteria {
    legalFormId: string;
    countryISO31661Alpha2Code: string;
}
